// extracted by mini-css-extract-plugin
export var legendIndicator = "_ed-1";
export var legendRight = "_ed-0";